 
<template>   
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true" >  
        <div class="modal-dialog" style="max-width:1700px;">  
            <div class="modal-content" style="min-height: 450px;">  
                <div class="modal-header"> 
					<h2>Atualizar</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg" />
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y m-5"  >
                    <div class="row g-6 g-xl-12"   >  
                        <ListaCampoForm :campos="campos" :formulario="formulario"   ></ListaCampoForm>  
                    </div>  
				</div>  
                <div class="modal-footer"  > 
                    <BotaoSalvar  @click="salvar" :processando="processando" titulo="Atualizar"></BotaoSalvar>   
				</div> 
			</div> 
		</div> 
	</div> 
</template>

<script lang="ts">
	  
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue'; 
    import { Options, Vue  } from "vue-class-component";  
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import NotaService from   "@/service/v1/sigap/NotaService"  
    import { Nota }  from   "./Nota"  
    import { PerfilConfig } from "@/core/config/PerfisConfig";
	import $ from "jquery"   
	  
    @Options({
        name: "NotaUpdate",
        components: {  ListaCampoForm, BotaoSalvar },   
        emits: [  'update-nota-alterado'],  
    }) 
    export default class NotaUpdate extends Vue {
 
        @Prop( ) readonly modal!: any 
        @Prop( ) readonly perfis!: any   
        @Prop( ) readonly modelo!: any
         
        public service = new NotaService();   
        public processando = false;  
        public formulario: any  = { } ;  
        public campos: Array<any> = [ ];
     
        async created() {  
            this.campos =  Nota.campos(); 
            if(this.modelo != null){
                this.modeloAlterado();
            }    
            await this.buscarStatus(); 
        } 
        
        public async buscarStatus(){   
            await this.service.getStatus(  ).then(response =>{ 
               this.campos.push(
                    {
                        nome: "status",
                        type: "select",
                        label: "Status",
                        sm: 6,
                        lg: 6, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }
   
        
        public modeloAlterado(){   
            this.formulario = {}
            if(this.modelo){  
                this.service.getModel(this.modelo.id) 
                .then(response => {   
                    this.formulario =  JSON.parse(JSON.stringify( response ));    
                    this.formulario.status = this.formulario.status.id; 
                    this.formulario.tipo = this.formulario.tipo.id; 
                })
                .catch(error => {
                    this.formulario = { };  
                });   
            } 
        }

        @Watch('modelo')
		modeloAtualizada(newVal: string) { 
            this.modeloAlterado(); 
		}
 
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
   
        public sucesso(){  
            this.$emit("update-nota-alterado", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }

        public getdados(){  
            let dados = JSON.parse(JSON.stringify(this.formulario)); 
            return dados;
        }

        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.update(  this.modelo.id, dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Atualizado com sucesso! ' ,  response.message  );
                    this.sucesso();  
                    this.formulario = {};
                    this.processando = false ;  
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100); 
        }  


    }    
</script>
 
<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    }
    .registro-alteracao{
        text-align: right;
    }

</style>